import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";

const CobranzaAjusteModal = ({ visible, onClose, pacienteID, pacienteNombre, periodo, cargosIniciales, descuentosIniciales, observacionInicial, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [cargos, setCargos] = useState("");
    const [descuentos, setDescuentos] = useState("");
    const [observacion, setObservacion] = useState("");

    useEffect(() => {
        if (visible) {
            setCargos(cargosIniciales || 0);
            setDescuentos(descuentosIniciales || 0);
            setObservacion(observacionInicial || "");
        }
    }, [visible, cargosIniciales, descuentosIniciales, observacionInicial]);

    if (!visible) return null;

    const handleGuardar = async () => {
        try {
            setLoading(true);
            const numCargos = Number(cargos) || 0;
            const numDescuentos = Number(descuentos) || 0;

            await axiosInstance.post("/acuerdo-mutuo/cobranza/ajuste", {
                paciente_id: pacienteID,
                periodo: periodo,
                otros_suma: numCargos,
                otros_resta: numDescuentos,
                observacion: observacion
            });

            alert("Valores ajustados correctamente.");
            if (onSuccess) onSuccess(); // Llamamos onSuccess sin argumentos porque ahora vamos a recargar la tabla en el padre.
            onClose();
        } catch (error) {
            console.error(error);
            alert("Error al guardar ajustes");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-warning">
                        <h5 className="modal-title text-dark">
                            <i className="bi bi-sliders me-2"></i> Ajustes - {pacienteNombre}
                        </h5>
                        <button className="btn-close" onClick={onClose} disabled={loading}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label fw-bold">Otros Suma</label>
                            <div className="input-group">
                                <span className="input-group-text">$</span>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    value={cargos} 
                                    onChange={e => setCargos(e.target.value)} 
                                    disabled={loading} 
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Otros Resta</label>
                            <div className="input-group">
                                <span className="input-group-text">$</span>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    value={descuentos} 
                                    onChange={e => setDescuentos(e.target.value)} 
                                    disabled={loading} 
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Observación</label>
                            <textarea 
                                className="form-control" 
                                rows="3" 
                                value={observacion} 
                                onChange={e => setObservacion(e.target.value)} 
                                disabled={loading}
                                placeholder="Especifique el motivo de los montos modificados..."
                            ></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancelar</button>
                        <button className="btn btn-warning" onClick={handleGuardar} disabled={loading}>Guardar Cambios</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CobranzaAjusteModal;
